module.exports = __webpack_public_path__ + "static/favicon-07d9beffa7092de321e254e101c2d7ec.ico";